import React from 'react';
import ApprovalList from '../ApprovalList';
import IPublishRequestOverview from '@Shared.Angular/@types/core/contracts/queryModel/governance/publishRequestOverview';

interface Props {
  isMobile: boolean;
  filteredItems: IPublishRequestOverview[];
}

const MyApprovalList: React.FC<Props> = ({ isMobile, filteredItems }) => {
  return (
    <ApprovalList
      isMobile={isMobile}
      filteredItems={filteredItems}
      roleLabel="Requested By"
      displayField="creatorName"
      emptyStateData={{
        summaryText: 'There are no pending publish requests',
        bodyText:
          'You’re all set! No publish requests are waiting for you at the moment'
      }}
    />
  );
};

export default MyApprovalList;
